import { render, staticRenderFns } from "./EsferaSenhas.vue?vue&type=template&id=5e61f71b&"
import script from "./EsferaSenhas.vue?vue&type=script&lang=js&"
export * from "./EsferaSenhas.vue?vue&type=script&lang=js&"
import style0 from "./EsferaSenhas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports